import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox ,faImage } from "@fortawesome/free-solid-svg-icons";
import MenuFooter from "./Component/MenuFooter";
import Header from "./Component/Header1";


const Orders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("live");
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES || "";

  useEffect(() => {
    fetchCustomerOrders();
  }, []);

  /** 🔥 Fetch Sales Orders from Correct API */
  const fetchCustomerOrders = async () => {
    try {
      setLoading(true);

      const userData =
        JSON.parse(sessionStorage.getItem("userData")) ||
        JSON.parse(localStorage.getItem("userData"));

      if (!userData || !userData._id) return;

      const token = userData.token || sessionStorage.getItem("token");

      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/get-orders-by-customer?customer_id=${userData._id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );

      const data = await response.json();
      console.log("Orders API Response:", data);

      if (data.success && Array.isArray(data.data)) {
        setOrders(data.data); // 🔥 USE RAW API DATA — NO REMAPPING
      }
    } catch (error) {
      console.error("Error fetching customer orders:", error);
    } finally {
      setLoading(false);
    }
  };

  /** 🔥 Navigate To Order Details */
  const handleOrderClick = (order) => {
    navigate("/consumer/app/orderdetails", {
      state: { orderId: order.order_id, quotationId: order?.quotation_id },
    });
  };

  /** 🔥 Get product image */
  const getItemImageUrl = (item) => {
    if (item?.item_image) return `${imageUrl}${item.item_image}`;
    return "";
  };

  /** 🔥 Status styles */
  const statusStyles = {
    delivered: "bg-green-50 text-green-700 border border-green-100",
    pending: "bg-yellow-50 text-yellow-700 border border-yellow-100",
    cancelled: "bg-gray-50 text-gray-600 border border-gray-200",
    default: "bg-gray-50 text-gray-600 border border-gray-200",
  };

  const getStatusStyle = (status) => {
    if (!status) return statusStyles.default;
    const s = status.toLowerCase();
    if (s.includes("deliver")) return statusStyles.delivered;
    if (s.includes("progress") || s.includes("confirm")) return statusStyles.pending;
    if (s.includes("cancel")) return statusStyles.cancelled;
    return statusStyles.default;
  };

  /** 🔥 Filters */
  const sortedOrders = [...orders].sort(
  (a, b) => new Date(b.order_date) - new Date(a.order_date)
);

const liveOrders = sortedOrders.filter((o) => o.is_live_order === true);
const closedOrders = sortedOrders.filter((o) => o.is_live_order === false);

  const finalOrders = activeTab === "live" ? liveOrders : closedOrders;

  if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400 text-xs">Loading Orders...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header title="My Orders" showSearch={false} backPath="/consumer/projectdetails" />

      {/* 🔥 Tabs */}
      <div className="sticky top-0 z-20 bg-gray-100 px-6 mt-4 flex justify-between items-center">
        {["live", "closed"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`relative flex-1 text-center text-lg font-medium transition-all duration-200 ${
              activeTab === tab ? "text-red-600" : "text-gray-700"
            }`}
          >
            {tab === "live" ? "Live" : "Closed"}

            {activeTab === tab && (
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-10 h-[3px] bg-red-500 rounded-full transition-all duration-300" />
            )}
          </button>
        ))}
      </div>

      {/* 🔥 ORDER LIST */}
      <div className="flex-1 px-4 py-3 mb-16">
        {finalOrders?.length > 0 ? (
          <div className="flex flex-col gap-3 mt-2 mb-2">
            {finalOrders.map((order, i) => {
              const images = order.items.slice(0, 2);
              const extra = order.items.length > 2 ? order.items.length - 2 : 0;

              return (
                <div
                  key={i}
                  onClick={() => handleOrderClick(order)}
                  className="bg-white rounded-2xl border border-gray-200 shadow-sm p-3 cursor-pointer hover:shadow-md hover:-translate-y-[2px] transition-all duration-150"
                >
                  {/* TOP */}
                  <div className="flex justify-between items-start">
                    <p className="text-[13px] font-semibold text-gray-900">
                      {order.order_number}
                    </p>
                    <p className="text-[14px] font-bold text-gray-900">
                     ₹{order.total.toLocaleString('en-US')}
                    </p>
                  </div>

                  {/* PRODUCT IMAGES */}
                  <div className="flex items-center mt-2">
                    {images.length > 0 ? (
                      <>
                        {images.map((img, i) => (
                          <div
                            key={i}
                            className="w-8 h-8 rounded-full overflow-hidden border-2 border-white"
                            style={{ marginLeft: i === 0 ? 0 : -10 }}
                          >
                            <img
                              src={getItemImageUrl(img)}
                              alt="item"
                              className="w-full h-full object-cover"
                            />
                          </div>
                        ))}
                        {extra > 0 && (
                          <div
                            className="w-8 h-8 rounded-full bg-gray-200 text-gray-600 text-[10px] flex items-center justify-center border-2 border-white"
                            style={{ marginLeft: -10 }}
                          >
                            +{extra}
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-[10px] text-gray-500">No Image</div>
                    )}

                    <span className="ml-2 text-[12px] text-gray-700 font-medium truncate">
                      {order.product_categories?.length > 1
                        ? `${order.product_categories[0].product_category_name} & more`
                        : order.product_categories?.[0]?.product_category_name ||
                          "General"}
                    </span>
                  </div>

                  {/* STATUS */}
                  <div
                    className={`rounded-lg px-2 py-1 mt-3 ${getStatusStyle(
                      order.status
                    )}`}
                  >
                    <p className="text-[12px] font-semibold truncate">{order.status}</p>
                  </div>

                  {/* DATE */}
                  <p className="text-[11px] text-gray-500 mt-2">
                    {new Date(order.order_date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </p>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-10">
            <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mb-2">
              <FontAwesomeIcon icon={faBox} className="text-gray-400 text-lg" />
            </div>
            <p className="text-gray-700 text-sm font-medium">No orders found</p>
            <p className="text-gray-500 text-xs">You haven’t placed any orders yet.</p>
          </div>
        )}
      </div>

      <div className="fixed bottom-0 left-0 right-0 z-50">
        <MenuFooter />
      </div>
    </div>
  );
};

export default Orders;
